import React from 'react';
import ReactDOM from 'react-dom/client';
// import 'semantic-ui-css/semantic.min.css'
// import './semantic.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const myoRoot = ReactDOM.createRoot(document.getElementById('myoRoot'));
myoRoot.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
